import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import { ROLL_CALL_API_BASE_URL } from "../../RollCallConfig/RollCallConfig";
// import { Spin } from "antd";

const AddDepartment = ({ fetchDepartments, onClose, isOpen }) => {
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  const handleSave = async (e) => {
    setloading(true);
    e.preventDefault();
    if (tokenData && superIdData) {
      const updatedData = {
        superid: superIdData,
        name: name,
        code: code,
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/department/createdepartment`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(updatedData),
          }
        );
        const result = await response.json();

        if (result?.status) {
          Swal.fire({
            title: "Success",
            text: " Department Added successfully",
            icon: "success",
          }).then(() => {
            fetchDepartments();
            handlecancel();
            onClose();
          });
        } else {
          Swal.fire(
            "Error",
            result.message || "Failed to add department",
            "error"
          );
        }
      } catch (error) {
        console.error("Error creating department:", error);
        Swal.fire("Error", "Something went wrong", "error");
      } finally {
        setloading(false);
      }
    }
  };

  const handlecancel = () => {
    setName("");
    setCode("");
  };

  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasRightAddDepartment");

    const handleOffcanvasClose = () => {
      handlecancel();
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasClose);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasClose
        );
      }
    };
  }, []);

  return (
    <>
      {isOpen && (
        <div>
          {/* {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )} */}
          <style>
            {`
        @media (max-width: 576px) {
          #offcanvasRightAddDepartment {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightAddDepartment {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightAddDepartment {
            width: 32% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightAddDepartment {
            width: 20% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightAddDepartment {
            width:15% !important;
          }
        }
        `}
          </style>

          <div className="offcanvas-backdrop fade show" onClick={onClose} />

          <div
            className="offcanvas offcanvas-end show"
            id="offcanvasRightAddDepartment"
            style={{ visibility: "visible" }}
          >
            <div className="offcanvas-header">
              <h4>Add Department</h4>
              <button
                type="button"
                className="btn-close text-reset"
                onClick={() => {
                  handlecancel();
                  onClose();
                }}
                aria-label="Close"
              />
            </div>
            <hr className="m-0 p-0" />
            <div className="offcanvas-body">
              <form onSubmit={handleSave}>
                <div className="content">
                  <div className="row">
                    <div className="mb-3">
                      <label className="form-label">
                        <span className="text-danger ms-1">*</span>Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                    <div>
                      <label className="form-label">
                        <span className="text-danger ms-1">*</span>Code
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter code"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="row d-flex justify-content-end mt-3">
                    <div
                      className="col-3 d-flex justify-content-end"
                      style={{ marginRight: "20px" }}
                    >
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        // disabled={loading}
                        onClick={() => {
                          handlecancel();
                          onClose();
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-2 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-success"
                        // disabled={loading}
                      >
                        {loading ? " Saving..." : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

AddDepartment.propTypes = {
  fetchDepartments: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.func.isRequired,
};

export default AddDepartment;
